<template>
  <v-dialog v-model="dialogHistoryProxy" max-width="1024px">
    <v-card>
      <v-card-title>
        <span class="text-h5">History Pelatihan</span>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>No</th>
                <th>Kegiatan</th>
                <th>Nama Pelatihan/ Judul</th>
                <th>Tempat</th>
                <th>Tanggal</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in table.items" :key="item.id">
                <td>{{ index + 1 }}</td>
                <td>
                  <v-chip color="warning" small v-if="item.id_pelatihan == -1">PELATIHAN EKSTRENAL</v-chip>
                  <v-chip color="success" small v-else>PELATIHAN INTERNAL</v-chip>
                </td>
                <div v-frag v-if="item.id_pelatihan == -1">
                  <td>{{ item.judul }}</td>
                  <td>{{ item.tempat }}</td>
                </div>
                <div v-frag v-else>
                  <td>{{ item.nama }}</td>
                  <td>RSUD dr. Soeselo</td>
                </div>
                <td>
                  {{ formatDate(item.tgl_pelaksaan_awal) }}
                  {{
                    item.tgl_pelaksaan_awal == item.tgl_pelaksaan_akhir
                      ? ''
                      : `s/d ${formatDate(item.tgl_pelaksaan_akhir)}`
                  }}
                </td>
                <td>
                  <div v-if="item.id_pelatihan == -1">
                    <a :href="item.link_sertifikat" target="_blank"
                      ><v-btn title="Lihat" x-small color="success" class=""> Lihat Sertifikat </v-btn></a
                    >
                  </div>
                  <div v-else>
                    <v-btn v-if="item.status == 'SELESAI'" x-small color="success" @click="gotoLihatSertifikat(item.id_pelatihan_peserta)"
                      >Lihat Sertifikat</v-btn
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import frag from 'vue-frag'
export default {
  name: 'HistoryPelatihanUser',
  directives: {
    frag,
  },
  props: {
    dialogHistory: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tableOptions: {},
      table: {
        loading: true,
        items: [],
        totalItems: 0,
      },
    }
  },
  computed: {
    dialogHistoryProxy: {
      get() {
        return this.dialogHistory
      },
      set(value) {
        this.$emit('update:dialogHistory', value)
      },
    },
  },
  watch: {
    dialogHistory: {
      immediate: true, // Runs getData() on initial load as well
      handler(newVal, oldVal) {
        this.getData(newVal)
      },
    },
  },
  methods: {
    getData(history) {
      //   console.log('Fetching data for history:', history)
      if (history) {
        axiosGetAuth(`api/Pelatihan/getStatusPelatihanPesertaById/${this.userId}`)
          .then(response => {
            this.table.items = response.data
            this.table.loading = false
          })
          .catch(error => {
            alert(error)
          })
      }
    },
    gotoLihatSertifikat(pelatihan_peserta_id) {
      window.open(
        `${process.env.VUE_APP_APIROOT}/Cetak/viewSertifikat/${this.$store.state.token}/${pelatihan_peserta_id}`,
        '_blank',
      )
    },
  },
}
</script>